jQuery(function($) {
    let form = $('.pre-order-form').parent();

    $('.pre-order-modal').each(function() {
        $(this).on('shown.bs.modal', function () {
            const productName = $(this).attr('data-product-name');
            form.find('.reset-input input').trigger('click');
            $(this).find('.product-name input').attr('value', productName);
        })
    
        $(this).on('hidden.bs.modal', function () {
            form.find('.reset-input input').trigger('click');
            $(this).find('.product-name input').attr('value', '');
        })
    })
});
